<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
    <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration " to="/admin/overview"> Home </router-link> <span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>CRM Notes<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmscrm/index">Manage CRM Notes </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update CRM Notes  </h6>
  <h6 class="custom-maintitle mb-2"><b>Update CRM Notes</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveCrm()" >







    <div class="row">
        <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Apt. No / Homeowner</label>
            <select @change="loadData(create_crm.idCustomer)" v-model="create_crm.idCustomer"  class="form-select font-size_def" aria-label="Default select example" required>
              <option selected></option>
              <option v-for="aprt in aprts" :key="aprt.id" :value="aprt.id">{{aprt.apt_no}}</option>
            
            </select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Contact</label>
            <select  v-model="create_crm.id_customer_contact"  class="form-select font-size_def" aria-label="Default select example" required>
              <option selected></option>
              <option v-for="customer_contact in customer_contacts" :key="customer_contact.idServicelog" :value="customer_contact.id">{{customer_contact.name}}</option>
            
            </select>
    
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Follow up Date</label>
            <input type="date" v-model="create_crm.followup_date" style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Follow up By</label>
            <input class="form-control" v-model="create_crm.followup_by" style="font-size: small;" placeholder="Select Contact" list="follow"  required>
                    <datalist id="follow" >
                       
                        <option v-for="user1 in user1s" :key="user1.id" >
                            {{ user1.username }} 
                        </option>
                        
                  
                    </datalist>
    </div>
  </div>
 
  
  

</div>

<div class="row">
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Comments</label>
           <textarea v-model="create_crm.comments" style="font-size: small;" class="form-control"  cols="30" rows="3"></textarea>
    </div>
  </div>

</div>




  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button :disabled="isButtonDisabled" type="submit" class="mr-1 btn custom-btn btn-primary  mb-5 font-size_def">Update</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        'idServicelog':this.$route.query.id,

        customer:{},
        aprts:[],
        crms:[],
        create_crm:{},
        customer_contacts:[],
        user1s:[],
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadApt(this.idServicelog);
    },
methods : {

  loadView(id){
    this.$router.push('/cmmscrm/view?id='+id);
  },

  async loadApt(id) {
    
    try {
      const { data} = await  axios.get('/mservicelog/loadaprt',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.aprts = data.aprt;
       this.user1s = data.user1;
      
    } catch (error) {
      console.log(error.response);
    }


    try {
      const { data} = await  axios.get('/mservicelog/loadalldata?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.create_crm = data.create_crm;
       this.customer_contacts = data.customer_contact;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async SaveCrm() {
    console.log(this.create_crm) ;
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/mservicelog/updatecrm',{userid:this.userid,create_crm:this.create_crm},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/cmmscrm/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
  async loadData(id) {
   
    try {
      const { data} = await  axios.get('/mservicelog/loaddetail?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       //this.customer = data.customer;
      // this.crms = data.crm;
       this.customer_contacts = data.customer_contact;
       //this.user1s = data.user1;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>